module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = events
// module chunks = 5